import { render } from "./normal-player-item.template.html?vue&type=template&id=67c41d5b&scoped=true"
import script from "./NormalPlayerItem.vue?vue&type=script&lang=ts"
export * from "./NormalPlayerItem.vue?vue&type=script&lang=ts"

import "./NormalPlayerItem.vue?vue&type=style&index=0&id=67c41d5b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67c41d5b"

export default script